;(() => {
  class DirAuto {
    arabicSymbolsRE = new RegExp(
      "[\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF]",
    )

    selector = ".js-dir-auto:not([dir])"

    ignoreSelector = ".js-dir-ignore"

    constructor(updateEvents) {
      this.updateEventsHandler = this.updateEventsHandler.bind(this)
      $(this.updateEventsHandler)
      $(document).on(updateEvents, this.updateEventsHandler)
    }

    updateEventsHandler() {
      $(this.selector).each((index, element) => {
        this.setDirection($(element))
      })
    }

    setDirection(el) {
      const text = this.getText(el)
      const direction = this.arabicSymbolsRE.test(text) ? "rtl" : "ltr"
      el.attr("dir", direction)
    }

    // return text of el ignoring children that match ignoreSelector
    getText(el) {
      const clone = el.clone()
      clone.find(this.ignoreSelector).remove()
      return clone.text()
    }
  }

  // hb:room-selected - happens in multi-group scenario when a room is selected
  new DirAuto("setup review:translated hb:room-selected")
})()
